import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "description p-text-bold p-text-capitalize" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  style: {"position":"absolute","right":"5px"},
  class: "pi pi-eye"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_PosDetailsStock = _resolveComponent("PosDetailsStock")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      style: _normalizeStyle(`background-image:url('${_ctx.getImage(_ctx.product.image)}')`),
      class: "card p-d-flex cursor-pointer p-align-center p-flex-column p-ripple"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-shop', $event))),
          class: "p-text-center p-d-flex p-justify-center p-align-center p-flex-column",
          style: {"width":"100%","height":"100%"}
        }, [
          _createElementVNode("div", null, _toDisplayString(_ctx.product.name), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.stockStatus), 1)
        ]),
        (_ctx.stockTotal)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_Divider, { class: "p-m-0" }),
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showStockDetails = true)),
                class: "p-d-flex p-justify-center p-align-center p-flex-column",
                style: {"width":"100%","height":"40px"}
              }, [
                _createElementVNode("div", { innerHTML: _ctx.stockTotal }, null, 8, _hoisted_2),
                _hoisted_3
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 4)), [
      [_directive_ripple]
    ]),
    (_ctx.showStockDetails)
      ? (_openBlock(), _createBlock(_component_PosDetailsStock, {
          key: 0,
          modelValue: _ctx.showStockDetails,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showStockDetails) = $event)),
          product: _ctx.product
        }, null, 8, ["modelValue", "product"]))
      : _createCommentVNode("", true)
  ], 64))
}